import { render, staticRenderFns } from "./section-benefits.vue?vue&type=template&id=6557dcc1&scoped=true"
import script from "./section-benefits.vue?vue&type=script&lang=js"
export * from "./section-benefits.vue?vue&type=script&lang=js"
import style0 from "./section-benefits.vue?vue&type=style&index=0&id=6557dcc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6557dcc1",
  null
  
)

export default component.exports